import React from 'react';
import Helmet from 'react-helmet';
import get from 'lodash/get';

const MetaTags = props => {
  const pageTitle = get(props, 'fields.MetaTitle.value', 'Page');
  const metaContent = get(props, 'fields.MetaDescription.value');
  const canonicalUrl = get(props, 'fields.canonicalUrl.value');
  const hrefLangTags = get(props, 'fields.IncludeHrefLang.value');
  const googleSiteVerificationKey = get(
    props,
    'fields.GoogleSiteVerificationKey.value',
  );
  const AlternativeImageRegion = get(
    props,
    'fields.AlternativeImageRegion.value',
  );
  const isOptimizelyEnabled = get(
    props,
    'fields.EnableOptimizelyScript.value',
    true,
  );
  const isOptimizelyOn = isOptimizelyEnabled && isOptimizelyEnabled !== 'False';
  return (
    <Helmet>
      <title>{pageTitle}</title>
      {Boolean(metaContent) && (
        <meta name="description" content={metaContent} />
      )}
      {Boolean(googleSiteVerificationKey) && (
        <meta
          name="google-site-verification"
          content={googleSiteVerificationKey}
        />
      )}
      {Boolean(isOptimizelyOn) && (
        <link rel="preconnect" href="https://cdn.optimizely.com" />
      )}
      {Boolean(isOptimizelyOn) && (
        <script src="https://cdn.optimizely.com/js/385364919.js"></script>
      )}
      {Boolean(AlternativeImageRegion) && (
        <meta name="AlternativeImageRegion" content={AlternativeImageRegion} />
      )}
      {Boolean(canonicalUrl) && <link rel="canonical" href={canonicalUrl} />}
      {Boolean(hrefLangTags) &&
        Object.entries(hrefLangTags).map(([key, value]) => (
          <link rel="alternate" hreflang={key} href={value} />
        ))}
    </Helmet>
  );
};

MetaTags.displayName = 'MetaTags';

export default MetaTags;
